import { apiClientAudio } from '@/plugins/axios'

export default {
  getMusicasEmEspera() {
    return apiClientAudio().get('/musica')
  },
  getMusicaEmEspera(id) {
    return apiClientAudio().get(`/musica/${id}`)
  },
  postMusicaEmEspera(musicaEmEspera) {
    let formData = new FormData()
    formData.append('description', musicaEmEspera.description)

    musicaEmEspera.files.forEach((file, key) => {
      formData.append(`audio-${key}`, file)
    })
    formData.append('digit', musicaEmEspera.digit)

    return apiClientAudio().post('/musica', formData)
  },
  putMusicaEmEspera(id, musicaEmEspera) {
    let formData = new FormData()

    formData.append('description', musicaEmEspera.description)
    formData.append('digit', musicaEmEspera.digit)
    formData.append('filesDelete', JSON.stringify({ filesDelete: musicaEmEspera.filesDelete }))

    musicaEmEspera.files.forEach((file, key) => {
      formData.append(`audio-${key}`, file)
    })
    return apiClientAudio().post(`/musica/${id}?_method=PUT`, formData)
  },
  deleteMusicaEmEspera(id) {
    return apiClientAudio().delete(`/musica/${id}`)
  },
}
